import { render } from "./CustomerSectionContact.vue?vue&type=template&id=5bd9f6bc"
import script from "./CustomerSectionContact.vue?vue&type=script&lang=js"
export * from "./CustomerSectionContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__